import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { motion } from "framer-motion";

const backURL = process.env.REACT_APP_BACK_URL;

const MeetingAuth = () => {
    const { meetingID } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [username, setUsername] = useState("");
    const [pin, setPin] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    // Accessing schedule data from previous route (if passed)
    const scheduleTitle = location.state?.trainingName || "Meeting Authentication";
    const scheduleTime = location.state?.scheduleTime
        ? new Date(location.state.scheduleTime).toLocaleString()
        : null;

    const token = localStorage.getItem("yariyan_gal" || "");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ name: username, meetingID, pin }),
        };

        try {
            const response = await fetch(`${backURL}/authenticate_meeting`, requestOptions);
            const result = await response.json();
            const { userID, fileID, language, status, msg } = result;

            if (status === 'success') {
                navigate('/livetraining/' + meetingID, {
                    state: {
                        pin,
                        liveUserID: userID,
                        name: username,
                        meetingUrl: meetingID,
                        file_ID: fileID,
                        lang: language,
                    },
                });
            } else {
                setError(msg);
            }
        } catch (err) {
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-500 to-purple-700 p-6">
            <div className="text-white text-center mb-6">
                <h3 className="text-2xl font-bold">{scheduleTitle}</h3>
                {scheduleTime && <p className="text-md mt-2">{scheduleTime}</p>}
            </div>

            <motion.div
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
                className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8"
            >
                <div className="flex items-center justify-center mb-6">
                    <ShieldCheck size={40} className="text-blue-600" />
                </div>
                <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Authenticate Meeting</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <input
                            type="text"
                            placeholder="Pin Code"
                            value={pin}
                            onChange={(e) => setPin(e.target.value)}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition"
                    >
                        {loading ? "Authenticating..." : "Authenticate"}
                    </button>
                    {error && <p className="text-red-500 mt-4 text-center">{error}</p>}
                </form>

                {/* Go Back Button */}
                <div className="mt-6 text-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="text-blue-600 hover:underline"
                    >
                        ← Go Back
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export default MeetingAuth;
